<!-- navItem „Provisionssätze“ — die aus dieser Provisionszeile entstandenen Sätze. -->
<div class="cp-provision-contract-contract-agents">

    @if (!initialized) {
        <p-skeleton height="16rem"></p-skeleton>
    } @else if (!provisionContractId) {
        <p-message severity="info" text="Keine Provisionszeile ausgewählt." styleClass="w-full"></p-message>
    } @else if (contractAgentsWidget) {
        <mvs-widget #contractAgentsWidgetRef [widgetData]="contractAgentsWidget"></mvs-widget>
    }

</div>
